'use client';

import { FC, useMemo } from 'react';
import Opportunity from '../../../types/Opportunity';
import OpportunityCard from '../../OpportunityCard';
import clx from 'classnames';
import { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import Icon from '../../../Icon';
import generateOpportunityUrl from './generateOpportunityUrl';

type Props = {
	opportunities: Opportunity[];
};

const OpportunitiesList: FC<Props> = ({ opportunities }) => {
	
	return (
		<div className="w-full px-12 relative sm:-mx-12 sm:w-[calc(100%_+_12rem)]">
			<Swiper
				slidesPerView={1}
				spaceBetween={16}
				breakpoints={{
					720: {
						slidesPerView: 2,
						spaceBetween: 0,
					},
					1024: {
						slidesPerView: 3,
						spaceBetween: 0,
					},
					1360: {
						slidesPerView: 4,
						spaceBetween: 0,
					},
				}}
				slidesPerGroupAuto
				loop={true}
				className="w-full [&_.swiper-wrapper]:min-h-[310px] [&_.swiper-wrapper]:items-stretch"
				navigation={{
					nextEl: `.button-next-opp`,
					prevEl: `.button-prev-opp`,
				}}
				modules={[Navigation]}
			>
				{opportunities?.map((opportunity, index) => (
					<SwiperSlide className="p-6 !h-auto flex self-stretch items-stretch justify-center" key={index}>
						<OpportunityCard
							href={generateOpportunityUrl(opportunity)}
							key={opportunity.cod}
							{...opportunity}
							as="li"
							className="shadow-lg h-full"
						/>
					</SwiperSlide>
				))}
			</Swiper>
			<div className="w-16 h-full flex items-center justify-end z-20 absolute top-0 right-0">
				<button type="button" title="Próximo parceiro" className={`button-next-opp w-14 h-14 bg-white rounded-full shadow-lg flex border border-gray-100 items-center justify-center hover:scale-105 transition-transform disabled:opacity-50 disabled:cursor-default cursor-pointer text-gray-600 hover:text-[#0F1DD7]`}>
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-6 w-6 shrink-0" aria-hidden>
						<path d="M5 12h14"></path>
						<path d="m12 5 7 7-7 7"></path>
					</svg>
				</button>
			</div>
			<div className="w-16 h-full flex items-center justify-start z-20 absolute top-0 left-0">
				<button
					type="button"
					title="Parceiro anterior"
					className={`button-prev-opp w-14 h-14 bg-white rounded-full shadow-lg flex border border-gray-100 items-center justify-center hover:scale-105 transition-transform disabled:opacity-50 disabled:cursor-default cursor-pointer text-gray-600 hover:text-[#0F1DD7]`}
				>
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-6 w-6 shrink-0" aria-hidden>
						<path d="m12 19-7-7 7-7"></path>
						<path d="M19 12H5"></path>
					</svg>
				</button>
			</div>
		</div>
	);
};

export default OpportunitiesList;
